/* @flow */
import {combineReducers} from 'redux'

import {routerReducer} from 'react-router-redux'

import authenticationReducer from './Authenticate/reducer'
import adminReducer from './Admin/reducer'

const reducers = {
  router: routerReducer,
  authentication: authenticationReducer,
  admin: adminReducer
}

export type Reducers = typeof reducers;

export default combineReducers(reducers)
